import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import './mutators/pillMutators';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailComposeSmartPill" */ './lazyIndex')
);

export const ComposeSmartPillBlock = createLazyComponent(lazyModule, m => m.ComposeSmartPillBlock);
export let lazyAddPill = new LazyAction(lazyModule, m => m.addPill);
export let lazyRemovePill = new LazyAction(lazyModule, m => m.removePill);
export { default as ComposeSmartPillData } from './store/schema/ComposeSmartPillData';
export { ComponentClass } from 'react';
